const TITLE_BANNED_CHARS = [
  "!",
  '"',
  "#",
  "$",
  "%",
  "&",
  "'",
  "(",
  ")",
  "*",
  "+",
  ",",
  "-",
  ".",
  "/",
  ":",
  ";",
  "<",
  "=",
  ">",
  "?",
  "@",
  "[",
  "\\",
  "]",
  "^",
  "_",
  "`",
  "{",
  "|",
  "}",
  "~",
  "×",
  "–",
  "°",
  "—",
  "−",
  "‐",
  "‑",
  "‒",
  "―",
  "，",
  "。",
  "、",
  "；",
  "：",
  "？",
  "！",
  "…",
  "《",
  "》",
  "【",
  "】",
] as const;

const escapeRegExp = (value: string) => value.replace(/[\\^$.*+?()[\]{}|/-]/g, "\\$&");

const TITLE_BANNED_CHARS_SET = new Set<string>(TITLE_BANNED_CHARS);

/** TikTok 短标题不允许出现的字符（与展示文案保持一致） */
export const TITLE_BANNED_REGEX = new RegExp(`[${TITLE_BANNED_CHARS.map(escapeRegExp).join("")}]`);

/** 提取 value 中命中的违规字符，按出现顺序去重，用空格连接 */
export const getTitleBannedCharsInValue = (value: string): string => {
  const seen = new Set<string>();
  const hits: string[] = [];
  for (const ch of value) {
    if (TITLE_BANNED_CHARS_SET.has(ch) && !seen.has(ch)) {
      seen.add(ch);
      hits.push(ch);
    }
  }
  return hits.join(" ");
};
